// STRPERF — shop behaviour on top of Horizon.
(() => {
  const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  const onCartPage = () => location.pathname.replace(/\/$/, '').endsWith('/cart');

  // After a successful "add to cart", take the customer to the cart page: that is where the
  // premium checkout moment lives. Horizon adds through fetch('/cart/add'), so the call is
  // watched here without touching the theme's own scripts.
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const request = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js|\.json)?$/.test(url.split(/[?#]/)[0]) && !onCartPage()) {
      request
        .then((response) => {
          if (response.ok) setTimeout(() => { location.href = cartUrl; }, 650);   // lets the add animation play
        })
        .catch(() => {});
    }
    return request;
  };

  // Gentle parallax on the wheels behind the cart.
  const wheels = document.querySelectorAll('.sp-cart-stage__wheel');
  if (wheels.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let frame = 0;
    window.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const y = window.scrollY;
        wheels.forEach((wheel, i) => wheel.style.setProperty('--sp-par', (y * (i ? -0.06 : 0.1)).toFixed(1) + 'px'));
      });
    }, { passive: true });
  }
})();
